import User from '../models/user'
import {
  generateFiles
} from './generator'
import Table from '../models/tables'
import TableT from '../models/tebleT'
import moment from 'moment'
const resolvers = {
  Query: {
    welcome: (_, data, context) => {
      if (context.user) {
        return ("welcome " + context.user.username);
      } else {
        return ("welcome anynomus");
      }
    },
    tableTest: () => {

      return TableT.findOne().exec()
    },
    tableTest2: () => {
              let table1 = TableT.create({name:"test"})
            return table1
          },
    time: () => {
      return moment().format();
    }



  },
  Mutation: {
    registerSchema: (_, data) => {
      console.log(Table.create(data));

      return "done"
    },
    generateFiles: (_, data) => {
      Table.find().then((tables) => {
        const options = {title:data.title,db:data.db}
        generateFiles(tables,options)
      })

      return "done"

    }
  }



}

export default resolvers